export default __webpack_public_path__ + "static/media/Walker's Vambraces of the Mound.37c66c7f.jpg";